import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { vendorsMainRoute } from '..';
import { type AppliesToType } from '../FundingTermsView/constants';

const fundingTermsSearchSchema = z.object({
  baseTermsModalOpen: z.boolean().optional(),
  q: z.string().optional(),
  baseTermId: z.string().optional(),
  budgetId: z.string().optional(),
  productFamilyIds: z.array(z.string()).optional(),
  fundingBasis: z.array(z.string()).optional(),
  receivingFlow: z.array(z.string()).optional(),
  status: z.array(z.string()).optional(),
  appliesTo: z.array(z.custom<AppliesToType>()).optional(),
  fundingType: z.array(z.string()).optional(),
  type: z.string().optional(),
});

export const vendorLayoutRoute = createRoute({
  getParentRoute: () => vendorsMainRoute,
  component: lazyRouteComponent(() => import('./VendorLayout')),
  path: '$vendorId',
  validateSearch: z.object({ from: z.string().optional() }).parse,
  parseParams: (params) => ({
    vendorId: z.string().parse(params.vendorId),
  }),
});

// TODO: Gather all vendor layout route children in this file

export const vendorFundingsRoute = createRoute({
  getParentRoute: () => vendorLayoutRoute,
  path: 'fundings',
  component: lazyRouteComponent(() => import('../FundingTermsView/FundingTerms')),
  validateSearch: fundingTermsSearchSchema.parse,
});

export const fundingTermsLegacyPathRedirectRoute = createRoute({
  getParentRoute: () => vendorLayoutRoute,
  path: 'base-terms',
  component: () => null,
  validateSearch: fundingTermsSearchSchema.parse,
  beforeLoad: ({ params, location }) => {
    throw redirect({
      to: '/vendors/$vendorId/fundings',
      params: { vendorId: params.vendorId },
      search: location.search as z.infer<typeof fundingTermsSearchSchema>,
    });
  },
});
